// https://product-fabric.atlassian.net/servicedesk/admin/UF/request-types
const REQUEST_TYPE_ID = '215';
const EMBEDDABLE_KEY = '4cae372b-cdbc-4446-ae9f-0ba4efb03711';

interface Field {
  id: string;
  value: string | object | object[];
}

interface FeedbackValues {
  additionalFields: Field[];
  email?: string;
  feedbackText?: string;
  lookingFor: LookingForOption;
  name?: string;
  userCanBeContacted: boolean;
  userInterestedInResearch: boolean;
}

export enum LookingForOption {
  accessJira = 'accessJira',
  accessConfluence = 'accessConfluence',
  accessBitbucket = 'accessBitbucket',
  accessAnotherProduct = 'accessAnotherProduct',
  accessAdmin = 'accessAdmin',
  talkToSupport = 'talkToSupport',
  buyAnAtlassianProduct = 'buyAnAtlassianProduct',
  startATrialOfAnAtlassianProduct = 'startATrialOfAnAtlassianProduct',
  updateMyProfileDataOrPassword = 'updateMyProfileDataOrPassword',
  askAQuestionOnCommunity = 'askAQuestionOnCommunity',
  other = 'other',
}

export const DEFAULT_PROPS = {
  canBeContactedDefaultValue: 'yes',
  canBeContactedFieldId: 'customfield_11682',
  customerNameFieldId: 'customfield_11678',
  descriptionFieldId: 'description',
  emailFieldId: 'email',
  embeddableKey: EMBEDDABLE_KEY,
  enrollInResearchDefaultValue: 'enrolme',
  enrollInResearchFieldId: 'customfield_11683',
  requestTypeId: REQUEST_TYPE_ID,
  summaryFieldId: 'summary',
  typeBugDefaultValue: { id: '10796' },
  typeCommentDefaultValue: {
    id: '10797',
  },
  typeQuestionDefaultValue: {
    id: '10799',
  },
  typeSuggestionDefaultValue: {
    id: '10798',
  },
};

const mapFormToJSD = (values: FeedbackValues) => {
  const { lookingFor, feedbackText = '', email, name } = values;
  const fields = [
    {
      id: 'customfield_11705',
      value: DEFAULT_PROPS.typeCommentDefaultValue,
    },
    {
      id: DEFAULT_PROPS.summaryFieldId,
      value: `[Empty state] [${lookingFor}] - ${feedbackText.slice(0, 100)}`,
    },
    {
      id: DEFAULT_PROPS.descriptionFieldId,
      value: feedbackText,
    },
    {
      id: DEFAULT_PROPS.emailFieldId,
      value: email || 'do-not-reply@atlassian.com',
    },
    {
      id: DEFAULT_PROPS.customerNameFieldId,
      value: name || 'default user',
    },
  ];

  return {
    fields: [
      ...fields,
      values.userCanBeContacted
        ? {
            id: DEFAULT_PROPS.canBeContactedFieldId,
            value: DEFAULT_PROPS.canBeContactedDefaultValue,
          }
        : undefined,
      values.userInterestedInResearch
        ? {
            id: DEFAULT_PROPS.enrollInResearchFieldId,
            value: DEFAULT_PROPS.enrollInResearchDefaultValue,
          }
        : undefined,
      ...values.additionalFields,
    ].filter(Boolean),
  };
};

export const submitFeedback = (values: FeedbackValues) => {
  return fetch(
    `https://jsd-widget.atlassian.com/api/embeddable/${EMBEDDABLE_KEY}/request?requestTypeId=${REQUEST_TYPE_ID}`,
    {
      body: JSON.stringify(mapFormToJSD(values)),
      headers: {
        'Content-Type': 'application/json',
      },
      method: 'POST',
    },
  );
};
